import React, { useState } from 'react';
import { useFormikContext, FieldArray, getIn } from "formik";
import { Button, FormGroup, Input, Row, Col, Container } from "reactstrap";
import { FormLabel, FormValue } from '../Form/FormLabel';
import { useEdit } from '../../Services/EditContext';
import AircraftSelector from '../Form/SelectAircraft';
import ErrorMessage from '../Form/ErrorMessage'
import { showDate, showTime } from '../../utils/Helpers';
import { useEffect } from 'react';
import TimeSpan from './TimeSpan';
import DatePicker from '../Form/DatePicker';
import TimePicker from '../Form/TimePicker';
import AirportLookup from '../Form/AirportLookup';
import FormInput from '../Form/FormInput';
import { newShareCharter } from '../../utils/Shapes';
import ClientSelector from '../Form/ClientSelector';
import ClientDetailsCard from '../Cards/ClientDetailsCard';
import { useHistory } from 'react-router-dom';
import CompareFormValue from '../Form/CompareFormValue';
import { IChangeCharter } from '../../Models/IChangeCharter';
import { Moment } from 'moment';

interface PurchaseProps {
    multi?: boolean;
    purchase: unknown;
    route?: string;
    index: number;
    add?: (e: unknown) => unknown;
    remove: (params: unknown) => unknown;
    availablePassengers: number;
    newRequest?: unknown;
}
const PurchaseRow = ({ purchase, route, index, add, remove, availablePassengers, newRequest }: PurchaseProps) => {
    const { values } = useFormikContext();
    const [edit] = useEdit();
    const purchases = getIn(values, 'purchases');
    const status = getIn(values, `purchases[${index}].status`)
    const history = useHistory();
    const viewPurchase = (index) => {
        const id = getIn(values, `purchases[${index}].id`);
        history.push(route + '/' + id);

    }
    return <Row style={{ backgroundColor: index % 2 === 1 ? 'transparent' : '#f0f0f0' }}>

        <Col xs='6' sm='6'>
            <Row>
                <Col xs='4' style={{ paddingLeft: 15, paddingRight: 7 }} >
                    <FormInput id={`purchases[${index}].passengerName`} label={index === 0 ? 'Passenger' : undefined} />
                </Col>
                <Col xs='4' style={{ paddingLeft: 0, paddingRight: 7 }} >
                    <FormInput id={`purchases[${index}].contactNumber`} label={index === 0 ? 'Phone' : undefined} />
                </Col>
                <Col xs='4' style={{ paddingLeft: 0, paddingRight: 7 }} >
                    <FormInput id={`purchases[${index}].emailAddress`} label={index === 0 ? 'Email' : undefined} />
                </Col>
            </Row>
        </Col>
        <Col xs='6' sm='6'>
            <Row>
                <Col xs={purchase && !edit ? 4 : 3} style={{ paddingLeft: 0, paddingRight: 7 }} >
                    <FormInput type={'number'} id={`purchases[${index}].passengerWeight`} label={index === 0 ? 'Pax (kg)' : undefined} placeholder="Kg" />
                </Col>
                <Col xs={purchase && !edit ? 4 : 3} style={{ paddingLeft: 0, paddingRight: 7 }} >
                    <FormInput type={'number'} id={`purchases[${index}].freightWeight`} label={index === 0 ? 'Bag (kg)' : undefined} placeholder="Kg" />
                </Col>
                <Col xs={purchase && !edit ? 4 : 3} style={{ paddingLeft: 0, paddingRight: 7 }} >
                    <FormInput type={'number'} id={`purchases[${index}].cargoWeight`} label={index === 0 ? 'Cargo (kg)' : undefined} placeholder="Kg" />
                </Col>
                {(!purchase || edit) && <Col xs='3' style={{ paddingLeft: 7, paddingRight: 0 }} >
                    {index === 0 && <FormLabel>{' '}</FormLabel>}
                    <Row style={{ paddingLeft: 7 }}>
                        {edit && (purchases.length !== 1) ? <Button className='link' onClick={() => remove(index)}>remove</Button> : !edit && <Button onClick={() => viewPurchase(index)}>{status}</Button>}
                    </Row>
                    <Row style={{ paddingLeft: 7 }}>
                        {edit && ((index === purchases.length - 1) && index < availablePassengers - 1) ? <Button className='link' onClick={add}>add</Button> : null}
                    </Row>
                </Col>}

            </Row>
        </Col>
    </Row>


}
const Purchases = ({ purchase, route, availablePassengers }) => {
    const { values } = useFormikContext<any>();
    return <FieldArray
        name="purchases"
        render={({ push, remove }) => values.purchases && values.purchases.length > 0 ? values.purchases.map((x, index) =>
            <PurchaseRow purchase={purchase} route={route} availablePassengers={availablePassengers} multi key={index} index={index} add={() => push({ ...newShareCharter })} remove={() => remove(index)} />
        ) : null} />
}

interface ShareRowProps {
    index: number;
    route?: string;
    noEdit?: boolean;
    showShare?: unknown;
    purchase?: unknown;
}
const ShareRow = ({ route, purchase, index, noEdit, showShare }: ShareRowProps) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const maxWeight = getIn(values, `routes[${index}].payload`);
    const maxPassengers = getIn(values, `routes[${index}].passengerLimit`);
    const manifest = getIn(values, `routes[${index}].manifest`);
    const existingPassengers = manifest ? manifest.length : 0;
    const [edit] = useEdit();
    const existingWeight = manifest?.reduce((a, x) => a + (x.freightWeight ? x.freightWeight : 0) + (x.cargoWeight ? x.cargoWeight : 0) + (x.passengerWeight ? x.passengerWeight : 0), 0);
    const availableWeight = maxWeight - existingWeight;
    const availablePassengers = maxPassengers - existingPassengers;

    const setShare = (share) => {
        setFieldValue(`routes[${index}].share.enabled`, share)
        if (share) {
            setFieldValue(`routes[${index}].share.seatsAvailable`, availablePassengers);
            setFieldValue(`routes[${index}].share.totalWeightAvailable`, availableWeight);
            setFieldValue(`routes[${index}].share.costPerSeat`, 500);
        }
    }
    const share = getIn(values, `routes[${index}].share.enabled`);
    const seatsAvailable = getIn(values, `routes[${index}].share.seatsAvailable`);
    const costPerSeat = getIn(values, `routes[${index}].share.costPerSeat`);

    const purchasedSeats = getIn(values, `routes[${index}].share.purchasedSeats`);
    const status = getIn(values, `routes[${index}].share.status`);
    const purchasedWeight = getIn(values, `routes[${index}].share.purchasedWeight`);


    return noEdit && seatsAvailable ? <Row>
        <Col>
            <FormLabel>Sharing {seatsAvailable} seats at ${costPerSeat} - {purchasedSeats ? purchasedSeats : 'none'} purchased.</FormLabel>
        </Col>
    </Row> :
        <React.Fragment >
            {//@ts-ignore
                purchase && edit ? <ClientSelector route={route} id='purchaseClientId' name='purchaseClientId' noEdit={noEdit} /> : <ClientDetailsCard />}

            {status}
            {showShare && edit ? (share ? (purchasedSeats ? null : <Button onClick={() => setShare(false)}>Don't share</Button>) : <Button onClick={() => setShare(true)}>Share this segment</Button>) : null}
            {share && existingPassengers ? <Row>
                <Col><FormInput noEdit={purchase || purchasedSeats} type="number" min={1} max={availablePassengers} label={"Seats (" + availablePassengers + " available, " + (purchasedSeats ? purchasedSeats + " purchased)" : ")")} id={`routes[${index}].share.seatsAvailable`} displayValue={availablePassengers - purchasedSeats} /></Col>
                <Col><FormInput noEdit={purchase || purchasedSeats} type="number" suffix='kg' min={50} max={availableWeight} label={"Payload  (" + availableWeight + " available, " + (purchasedWeight ? purchasedWeight + " purchased)" : ")")} id={`routes[${index}].share.totalWeightAvailable`} displayValue={availableWeight - purchasedWeight} /></Col>
                <Col><FormInput noEdit={purchase || purchasedSeats} type="number" prefix='$' label={"Cost per seat"} id={`routes[${index}].share.costPerSeat`} /></Col>
            </Row> : null}
            {share && !existingPassengers ? <Row><Col><h3>Sorry, but you need to fill out the Passenger list, before sharing charters, so that we can provide what we promise.</h3></Col></Row> : null}
            <Purchases purchase={purchase} route={route} availablePassengers={availablePassengers - purchasedSeats} />
        </React.Fragment>
}

type RowProps = {
    route?: string;
    insert?: (p: unknown) => void;
    index: number;
    finalising?: boolean;
    setEditManifest?: (val: boolean) => void;
    remove?: (e: unknown) => unknown;
    add?: (e: unknown) => unknown;
} & Record<string, unknown>;
const FlightRow = ({ newRequest, route, purchase, insert, share, compare, index, noEdit, placeBid, finalising, reverseLast, remove, add, setEditManifest }: RowProps) => {
    const { handleChange, setFieldValue, values } = useFormikContext<IChangeCharter>();
    const flightRoute = values.routes[index];
    const firstRoute = reverseLast ? values.routes[index - 1] : flightRoute;
    const [techstopEnabled, enableTechStop] = useState(!!flightRoute.techstopReason);
    const [edit] = useEdit();
    const supplierChange = compare && !!values.supplierInitiated;
    const clientChange = compare && !values.supplierInitiated;
    const change = clientChange || supplierChange;
    const remainingPayLoad = flightRoute.manifest?.length>0 ? (flightRoute.payload -
                                                            (flightRoute.manifest.reduce((a, x) => a + (x.freightWeight ? x.freightWeight : 0) + 
                                                            (x.cargoWeight ? x.cargoWeight : 0) + 
                                                            (x.passengerWeight ? x.passengerWeight : 0), 0))
                                                            ) : flightRoute.payload;
    const isConfirmedStatus = values.status==="Confirmed"?true:false;

    useEffect(() => {
        if (reverseLast) {
            setFieldValue(`routes[${index}].to` as unknown as keyof IChangeCharter, firstRoute.from);
            setFieldValue(`routes[${index}].from` as unknown as keyof IChangeCharter, firstRoute.to);
        }

    }, [firstRoute.to, firstRoute.from, reverseLast, index, setFieldValue])

    
    const originalFlighRoute = getIn(values, `original.routes[${index}]`);
    const lastDate = index ? getIn(values, `routes[${change ? 0 : index - 1}].viewDepartDate`) : null;
    const minDate = index ? new Date(lastDate ? lastDate : null) : new Date();

    const passengers = (flightRoute) => flightRoute.manifest?.length ? flightRoute.manifest?.length : flightRoute.passengerRange ? (flightRoute.passengerRange_Min === flightRoute.passengerRange_Max ? flightRoute.passengerRange_Min : flightRoute.passengerRange_Min + ' to ' + flightRoute.passengerRange_Max) :
        flightRoute.passengerNumber;
    const currentPassengers = passengers(flightRoute);
    const comparePassengers = originalFlighRoute ? passengers(originalFlighRoute) : currentPassengers;
    return (<Container style={{ backgroundColor: index % 2 === 1 ? 'transparent' : '#ebecfa' }}>
        {!supplierChange ? < Row >
            <Col>
                {change && index === 0 && add && edit && !noEdit ? <Button type="button" style={{ marginBottom: '15px' }} onClick={insert}>Insert Sector</Button> : null}
            </Col>
        </ Row> : null}

        <Row style={{ backgroundColor: index % 2 === 1 ? 'transparent' : '#ebecfa' }}>
            <Col xs='12' md='3'>
                <FormGroup>
                    <FormLabel>Date & Time</FormLabel>
                    <Col>
                        {edit && (!share || placeBid) ? <React.Fragment>
                            <Row>
                                <DatePicker id={`routes[${index}].viewDepartDate`}
                                    name={`routes[${index}].viewDepartDate`} minDate={minDate} type='date'
                                    placeholder="Depart Date" onChange={(e) =>
                                        setFieldValue(`routes[${index}].viewDepartDate` as unknown as keyof IChangeCharter, e)}
                                    selected={(flightRoute as any).viewDepartDate} />
                                <ErrorMessage name={`routes[${index}].viewDepartDate`} />
                            </Row>
                            <Row>
                                <TimePicker placeholder="Depart Time" onChange={(e: Moment) => {
                                    if (e) {
                                        const rawD = (values.routes[index] as unknown as { viewDepartDate: string | number | Date }).viewDepartDate;
                                        const d = (rawD instanceof Date ? rawD : new Date(rawD)).setHours(e.hours(), e.minutes());
                                        setFieldValue(`routes[${index}].viewDepartDate` as unknown as keyof IChangeCharter, d);
                                    }
                                    setFieldValue(`routes[${index}].viewDepartTime` as unknown as keyof IChangeCharter, e);
                                }} format="HH:mm" value={(flightRoute as any).viewDepartTime} />
                                <ErrorMessage name={`routes[${index}].viewDepartTime`} />
                            </Row>
                        </React.Fragment> : <Row>
                            {getIn(values, `original.routes[${index}].departTime`) !== flightRoute.departTime ? <FormValue style={{ color: 'red' }}><del>{getIn(values, `original.routes[${index}].departTime`)}</del></FormValue> : null}
                            <FormValue>{showDate(flightRoute.departTime) + '\n' + showTime(flightRoute.departTime)}</FormValue>
                        </Row>}
                    </Col>

                </FormGroup>
            </Col>
            {!reverseLast ? <Col xs='6' md='3'>

                <FormLabel>From</FormLabel>
                {//@ts-ignore
                    edit && !noEdit ? <AirportLookup dropDownLabel='Type your departure location' id={`routes[${index}].from`} stateId={`routes[${index}].fromState`} altStateId={`routes[${index}].fromAltState`} newStateId={`routes[${index}].fromStateNew`} placeholder="From" />
                        : <React.Fragment>
                            <CompareFormValue id={`routes[${index}].from`} />

                        </React.Fragment>}

            </Col> : <Col xs='6' md='3'>

                <FormLabel>From</FormLabel>
                <FormValue>{firstRoute.to}</FormValue>

                <ErrorMessage name={`routes[${index - 1}].to`} />
            </Col>}

            {!reverseLast ? <Col xs='6' md='3' >
                <FormLabel>To</FormLabel>
                {edit && !noEdit ? <AirportLookup dropDownLabel='Type your arrival location' id={`routes[${index}].to`} stateId={`routes[${index}].toState`} altStateId={`routes[${index}].toAltState`} newStateId={`routes[${index}].toStateNew`} placeholder="To" />
                    : <React.Fragment>
                        <CompareFormValue id={`routes[${index}].to`} />
                    </React.Fragment>}

            </Col> : <Col xs='6' md='3' >
                <FormLabel>To</FormLabel>
                <FormValue>{firstRoute.from}</FormValue>

            </Col>}

            <Col xs='6' md='3'>
                <FormLabel></FormLabel>
            </Col>
            <Col xs='6' md='3'>
                <FormLabel>
                    Passengers
                </FormLabel>
                {!flightRoute.manifest?.length ?
                    (edit && !noEdit ? <React.Fragment><FormGroup check inline>
                        <FormLabel check htmlFor={`routes[${index}].passengerRange`} style={{ display: 'block' }}>
                            <Input type='checkbox' id={`routes[${index}].passengerRange`} name={`routes[${index}].passengerRange`} placeholder="passengerRange" value={(flightRoute as any).passengerRange} onChange={handleChange} />
                            Use Range
                        </FormLabel>
                    </FormGroup>
                        {((flightRoute as any).passengerRange ? (edit || clientChange || share ? <React.Fragment>
                            <Input id={`routes[${index}].passengerRange_Min`} name={`routes[${index}].passengerRange_Min`} type='number' onChange={handleChange} value={flightRoute.passengerRange_Min} />
                            <FormLabel>To</FormLabel>
                            <Input id={`routes[${index}].passengerRange_Max`} name={`routes[${index}].passengerRange_Max`} type='number' onChange={handleChange} value={flightRoute.passengerRange_Max} />
                            <ErrorMessage name={`routes[${index}].passengerRange_Max`} />
                            <ErrorMessage name={`routes[${index}].passengerRange_Min`} />
                        </React.Fragment> : flightRoute.passengerRange_Min + ' to ' + flightRoute.passengerRange_Max) :
                            (edit ? <React.Fragment>
                                <Input id={`routes[${index}].passengerNumber`} name={`routes[${index}].passengerNumber`} type='number' onChange={handleChange} value={flightRoute.passengerNumber} />
                                <ErrorMessage name={`routes[${index}].passengerNumber`} />
                            </React.Fragment> : flightRoute.passengerNumber)
                        )}
                    </React.Fragment>
                        : <CompareFormValue originalContent={comparePassengers}>{currentPassengers}</CompareFormValue>)
                    : <React.Fragment>
                         <br/>
                    <FormValue>
                         {flightRoute.manifest?.length + ' person(s) '}
                    </FormValue>
                        <FormValue>
                        &nbsp;  {flightRoute.manifest?.length ? flightRoute.manifest.reduce((a, x) => a + (x.freightWeight ? x.freightWeight : 0) + (x.cargoWeight ? x.cargoWeight : 0) + (x.passengerWeight ? x.passengerWeight : 0), 0) + ' kg' : null
                            }
                        </FormValue>
                    </React.Fragment>}
            </Col>
            <Col xs='6' md='6'>
                <FormLabel></FormLabel>
            </Col>
            {isConfirmedStatus && remainingPayLoad!=null?
            <Col xs='6' md='3'>
                <FormLabel style={{ color: (remainingPayLoad>0)?'green':'red' }} >Payload Remaining</FormLabel>
                <br/>
                <FormValue>
                    {remainingPayLoad}
                </FormValue>
            </Col>:null
        }
        </Row>
        {(edit && !clientChange) || flightRoute.techstopReason || flightRoute.techstopLocation ? <Row>
            {edit && (supplierChange || placeBid) ? <Col xs='6' md='3'><FormLabel><Input type="checkbox"
                checked={!!techstopEnabled} placeholder="Tech Stop"
                onChange={({ target }) => {
                    if (!techstopEnabled) {
                        enableTechStop(true);
                        setFieldValue(`routes[${index}].techstopReason` as unknown as keyof IChangeCharter, "Fuel Stop");
                    }
                    else {
                        // Disable the tech stop
                        enableTechStop(false);
                        // Clear tech stop values for this route
                        setFieldValue(`routes[${index}].techstopLocation` as unknown as keyof IChangeCharter, "");
                        setFieldValue(`routes[${index}].techstopReason` as unknown as keyof IChangeCharter, "");
                        setFieldValue(`routes[${index}].techstopState` as unknown as keyof IChangeCharter, "");
                    }
                }} />Tech Stop</FormLabel></Col> : null}
            {techstopEnabled || (flightRoute.techstopReason && flightRoute.techstopLocation) ? <>
                <Col xs='6' md='3'>
                    <FormLabel>Tech Stop at</FormLabel>
                    {edit && !clientChange ? <AirportLookup dropDownLabel='Type your tech stop location' id={`routes[${index}].techstopLocation`} stateId={`routes[${index}].techstopState`} altStateId={`routes[${index}].techstopAltState`} newStateId={`routes[${index}].techstopStateNew`} placeholder="At" />
                        : <React.Fragment>
                            <CompareFormValue id={`routes[${index}].techstopLocation`} />
                        </React.Fragment>}
                </Col>
                <Col xs='6' md='3'>
                    <FormGroup>
                        <FormInput
                            noEdit={!edit || !!clientChange}
                            id={`routes[${index}].techstopReason`}
                            label="Reason"
                        />
                        <ErrorMessage name={`routes[${index}].techstopReason`} />
                    </FormGroup>
                </Col>
            </> : null}
        </Row> : null}
        {share || placeBid ? <div>
            <Row>
                <Col xs='6' md={edit ? '4' : '3'}>
                    <AircraftSelector compare={supplierChange} noEdit={share || clientChange} useAllId={'sameAircraft'} id={`routes[${index}].aircraft`} label='Aircraft' index={index} route={flightRoute} isMulti routeField='aircraft' passengerLimitField={`routes[${index}].passengerLimit`} />
                </Col>
                <Col xs='6' md='3'>
                    <FormLabel>Flight Time</FormLabel>
                    {!clientChange && edit && (!share || supplierChange) ?
                        //@ts-ignore
                        <TimeSpan id={`routes[${index}].flightTime`} onChange={handleChange} value={flightRoute.flightTime} />
                        :
                        <CompareFormValue id={`routes[${index}].flightTime`} />}
                    <ErrorMessage name={`routes[${index}].flightTime`} />
                </Col>
                <Col xs='6' md={edit ? '2' : '3'}>
                    <FormGroup>
                        <FormLabel>Pax Limit</FormLabel>
                        {!clientChange && edit && (!share || supplierChange) ?
                            <Input id={`routes[${index}].passengerLimit`} name={`routes[${index}].passengerLimit`} placeholder="Pax Limit" type='number' value={flightRoute.passengerLimit} onChange={handleChange} />
                            :
                            <CompareFormValue id={`routes[${index}].passengerLimit`} />}
                        <ErrorMessage name={`routes[${index}].passengerLimit`} />
                    </FormGroup>
                </Col>
                <Col xs='6' md='3'>
                    <FormGroup>
                        <FormLabel>Payload Available</FormLabel>
                        {!clientChange && edit && (!share || supplierChange) ?
                            <Input id={`routes[${index}].payload`} name={`routes[${index}].payload`} placeholder="Baggage Weight" type='number' value={flightRoute.payload} onChange={handleChange} />
                            :
                            <CompareFormValue id={`routes[${index}].payload`} />}
                        <ErrorMessage name={`routes[${index}].payload`} />
                    </FormGroup>
                </Col>
            </Row>
            {finalising ? <Row>

                && <Col xs='6' md='3'>
                    <FormGroup>
                        <FormLabel>From Airport</FormLabel>
                        <AirportLookup id={`routes[${index}].fromAirport`} placeholder="Airport" />
                        <FormValue>{flightRoute.fromAirport}</FormValue>
                        <ErrorMessage name={`routes[${index}].fromAirport`} />
                    </FormGroup>
                </Col><Col xs='6' md='3' >
                    <FormGroup>
                        <FormLabel>To Airport</FormLabel>
                        <AirportLookup id={`routes[${index}].toAirport`} placeholder="Airport" />
                        <FormValue>{flightRoute.toAirport}</FormValue>
                        <ErrorMessage name={`routes[${index}].toAirport`} />
                    </FormGroup>
                </Col>
            </Row> : null}
            {finalising && <Row >
                <Col xs='6' md='2'>
                </Col>
                <Col xs='6' md='3'>
                    <FormLabel>Pick up instructions</FormLabel>
                    <Input type='textarea' id={`routes[${index}].fromAirportDetail`} name={`routes[${index}].fromAirportDetail`} placeholder="Drop Off Instructions" value={flightRoute.fromAirportDetail} />
                    <FormValue>{flightRoute.fromAirportDetail}</FormValue>
                    <ErrorMessage name={`routes[${index}].fromAirportDetail`} />

                </Col>
                <Col xs='6' md='3' >
                    <FormGroup>
                        <FormLabel>Drop off instructions</FormLabel>
                        <Input type='textarea' id={`routes[${index}].toAirportDetail`} name={`routes[${index}].toAirportDetail`} placeholder="Pickup Instructions" value={flightRoute.toAirportDetail} />
                        <FormValue>{flightRoute.toAirportDetail}</FormValue>
                        <ErrorMessage name={`routes[${index}].toAirportDetail`} />
                    </FormGroup>
                </Col>
            </Row>}</div>
            : null}
        {!supplierChange ? < Row >
            <Col>
                {((change && values.routes.length > 1) || (index === values.routes.length - 1 && index > 0)) && remove && edit && !noEdit ? <Button type="button" onClick={remove} style={{ marginRight: '16px', marginBottom: '15px' }}>Remove Sector</Button> : null}

                {(change || index === values.routes.length - 1) && add && edit && !noEdit ? <Button type="button" style={{ marginRight: '15px', marginBottom: '15px' }} onClick={add}>Add Sector</Button> : null}
                {newRequest && index === values.routes.length - 1 ? <Button onClick={() => setEditManifest?.(true)} style={{ marginBottom: '15px' }}>Passengers</Button> : null}
            </Col>
        </ Row> : null}

        {!placeBid ? <ShareRow route={route} purchase={purchase} index={index} noEdit={!share} showShare={share} /> : null}


    </Container>)


}


export default FlightRow;